import { useRef } from 'react';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import './PDFViewer.css';
import {
  ModalContent,
  ModalFooter,
  SecondaryButton,
  PrimaryButton,
} from '../../../shared/modal/Modal';
import { fullScreen, openInNewWindow } from '../pdf-utils/pdf-modal-utils';

interface PDFViewerProps {
  src?: string;
  backToList: () => void;  // Pass the backToList function
}

export default function PDFViewer({ src, backToList }: PDFViewerProps) {
  const modalContentRef = useRef<HTMLDivElement | null>(null);

  const getTitle = (str?: string) => {
    if (!str) return undefined;
    return str.split('/').pop()?.replace('.pdf', '');
  };

  const openInNewWindowHandler = () => {
    if (src) openInNewWindow(src, getTitle(src));
  };

  const fullScreenHandler = () => {
    const ref = modalContentRef.current;
    fullScreen(ref);
  };

  return (
    <ModalContent
      ref={modalContentRef}
      height={'calc(100vh - 385px)'}
      width={'100%'}
    >
      <div className="pdf-viewer-content">
        <object>
          <iframe height={'100%'} width={'100%'} style={{transform: 'scale(1)'}} src={src} title={src}></iframe>
        </object>
      </div>

      <ModalFooter>
        <SecondaryButton 
          title="New Window"
          icon="esri-icon-launch-link-external"
          onClick={openInNewWindowHandler}
        />
        <PrimaryButton 
          title="Full Screen" 
          icon="esri-icon-zoom-out-fixed"
          onClick={fullScreenHandler}
        />
        <SecondaryButton 
          title="Back to List"
          icon="esri-icon-menu"
          onClick={backToList} // Navigate back to the list view
        />
      </ModalFooter>
    </ModalContent>
  );
}
